/**
 * 修改手机号页
 * 
 */


import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { getItem as getLang } from '../../common/lang';
import ajax, { ajaxDispatch } from '../../common/utils/ajax';
import { dispatch } from '../../dispatcher/Dispatcher';

import Header from '../../components/Header/Header.jsx';
import Form from '../../components/Form/Form.jsx';
import Button from '../../components/Button/Button.jsx';
import ConfirmMobile from '../ConfirmMobile/ConfirmMobile';
import UserStore from '../../stores/UserStore';

const changeMobileControls = [
  {
    type: 'password',
    id: 'password',
    name: 'password',
    label: getLang('PASSWORD'),
    required: true
  },
  {
    type: 'tel',
    id: 'mobile',
    name: 'mobile',
    label: getLang('NEW_MOBILE'),
    minLength: 11,
    maxLength: 11,
    required: true,
    tips: getLang('MOBILE_TIP')
  },
  {
    type: 'tel',
    id: 'captcha',
    name: 'captcha',
    label: getLang('CAPTCHA'),
    minLength: 6,
    maxLength: 6,
    required: true,
    tips: getLang('REQUIRED')
  }
];

const submitButton = {
  text: getLang('CHANGE_MOBILE')
};

class ChangeMobile extends Component {
  static getStores() {
    return [UserStore];
  }

  static calculateState() {
    return UserStore.getState();
  }

  constructor(props) {
    super(props);
    this.getCaptcha = this.getCaptcha.bind(this);
    this.state = {
      captchaTimer: 0
    };
  }

  render() {
    const { captchaTimer, goback } = this.state,
      getCaptchaText = captchaTimer ? `${captchaTimer} ${getLang('RETRY_CAPTCHA')}` : getLang('GET_CAPTCHA'),
      captchaDisabled = !!captchaTimer;
    //console.log(captchaDisabled);
    if (localStorage.mobile) {
      changeMobileControls[1].defaultValue = localStorage.mobile;
    }

    const props = this.props;
    this.state = {fromChangeMobile: props.fromChangeMobile};
    return (
     <div style={{ position: 'relative' }}>
         {
           localStorage.mobile
          ?props.fromChangeMobile
            ?<Header back title={getLang('CHANGE_MOBILE')} callback={::this.goback}  />
            :<Header back title={getLang('CHANGE_MOBILE')}  />
          :<Header back title={getLang('CHANGE_MOBILE')}  callback={::this.goLogout} />
         }
        <Form action='/change-mobile'
              controls={changeMobileControls}
              submitButton={submitButton}
              className='side-gap gap-t-lg'
              afterSubmit={this.getResult}></Form>

        <Button ref='getCaptcha'
                className='login-get-captcha'
                style={{ bottom: 'auto', top: '15.75rem' }}
                text={getCaptchaText} link
                onTouchTap={captchaDisabled?function(){}:this.getCaptcha} />        
        {/* <a href='#' onClick={::this.goback}>b</a> */}
      </div>
    );
  }

  goback(){
    //alert('goback');
    //alert(this.state.fromChangeMobile);
    // this.setState({editting:false});
    // this.setState({confirmMobilePhone: '158000448791'});
    localStorage.confirmMobilePhone = localStorage.mobile;
    localStorage.confirmMobileEditting = false;
    location.reload();
    
    
  }

  goLogout(){
    dispatch({type: 'logout'});
  }

  getCaptcha() {
    
    let timer = 61,
      timeout,
      mobile = document.getElementById('mobile').value,
      self = this;

    if (!(/^\d{11}$/.test(mobile))) return;

    function countDown() {
      timer -= 1;

      self.setState({
        captchaTimer: timer
      });

      if (timer === 0) {
        return clearTimeout(timeout);
      }

      timeout = setTimeout(countDown, 1000);
    }

    setTimeout(countDown, 0);

    ajax.post('/validation-no', {
      type: 0,
      phone: mobile
    }).then((res) => {
      console.log(res);
    })
      .catch(() => {
        clearTimeout(timeout);
        self.setState({
          captchaTime: 0
        });
      });
  }


  /**
   * Get change mobile result
   */
  getResult() {
    localStorage.needConfirmMobile = 0;
    localStorage.mobile = document.getElementById('mobile').value;
    alert(getLang('EDIT_SUCCESS'));

    if (location.hash.indexOf('change-mobile') > -1) {
      history.back();
    } else {
      location.reload();
    }
  }
}
export default Container.create(ChangeMobile);


// WEBPACK FOOTER //
// ./src/containers/Config/ChangeMobile.jsx